'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'handshake';
var width = 576;
var height = 512;
var aliases = [129309,62662,"handshake-alt","handshake-simple"];
var unicode = 'f2b5';
var svgPathData = ['M0 32L0 320 156.4 450.3c23 19.2 52 29.7 81.9 29.7l15.7 0-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l41 41 9 0c19.1 0 37.8-4.3 54.8-12.3L359 441c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l32 32 17.5-17.5c8.9-8.9 11.5-21.8 7.6-33.1l-137.9-136.8-14.9 14.9c-49.3 49.3-129.1 49.3-178.4 0-23-23-23.9-59.9-2.2-84L223.4 64 183.8 64c-25.5 0-49.9 10.1-67.9 28.1L112 96 0 32z', 'M152.3 214.8L268.9 85.2C281.1 71.7 298.4 64 316.5 64l70.4 0c19 0 37.5 5.6 53.3 16.1L464 96 576 32 576 320 505.6 376 329 200.8c-9.4-9.3-24.5-9.3-33.9 .1l-31.8 31.8c-30.5 30.5-80 30.5-110.5 0-4.9-4.9-5.1-12.8-.5-17.9z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHandshake = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;